import { render, staticRenderFns } from "./ModalAddTabelaOperadora.vue?vue&type=template&id=3c3da4ab"
import script from "./ModalAddTabelaOperadora.vue?vue&type=script&lang=ts"
export * from "./ModalAddTabelaOperadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports